import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import UserContext from '../../context/UserContext';
import { USER_LOGGED } from '../../context/UserReducer';
import { login } from '../../services/userService';
import { TextField, Button, Frame } from '@shopify/polaris';
import { SET_OK, SET_ERROR } from '../../context/ToastReducer';
import ToastContext from '../../context/ToastContext';
import AlertToast from '../../helpers/alertToast';

const Login = () => {
  const history = useHistory();
  // eslint-disable-next-line
  const [, dispatch] = useContext(UserContext);
  const [, dispatchToast] = useContext(ToastContext);

  const defaultLogin = {
    email: '',
    password: '',
  };
  const [loginForm, setLoginForm] = useState(defaultLogin);

  const handleLogin = (e) => {
    e.preventDefault();
    login(loginForm)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        localStorage.setItem('user', JSON.stringify(r.data));
        const redirectTo = window.location.pathname !== '/' ? window.location.pathname + window.location.search : '/dashboard';
        history.push(redirectTo);
        dispatch({ type: USER_LOGGED, payload: r.data });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return (
    <>
      <Frame>
        <div className="max-lg:grid max-lg:grid-rows-1 max-lg:grid-cols-1 max-lg:items-center lg:flex">
          <div className="max-lg:row-start-1 max-lg:row-span-1 max-lg:col-start-1 max-lg:col-span-1 lg:w-2/3 lg:h-screen">
            <img src="/MIRTO_MIXTA.jpeg" alt="imgLogin" className="object-cover	h-screen" />
          </div>
          <div className="max-lg:row-start-1 max-lg:row-span-1 max-lg:col-start-1 max-lg:col-span-1 lg:w-1/3 lg:px-8 lg:bg-gray-100 lg:flex lg:items-center">
            <form
              className="mx-4 mb-8 rounded-lg p-8 bg-white flex flex-col items-center  md:max-w-[450px] lg:max-w-[550px] md:mx-auto"
              onSubmit={handleLogin}
            >
              <img alt="logo" src="/mirtomex_logo.png" className="max-w-[140px] mb-8 border-b border-gray-100 pb-8" />
              <p className="text-center text-md w-3/5">Accede a MIRTOMEX con tu correo y contraseña</p>

              <div className="mt-8 w-5/6">
                <div data-test="primer-input" className="pb-5">
                  <TextField
                    className="textField"
                    type="email"
                    label="Email"
                    autoComplete="email"
                    value={loginForm.email}
                    onChange={(e) =>
                      setLoginForm({
                        ...loginForm,
                        email: e,
                      })
                    }
                  />
                </div>
                <div data-test="segundo-input" className="pb-5">
                  <TextField
                    type="password"
                    label="Contraseña"
                    value={loginForm.password}
                    autoComplete="on"
                    onChange={(e) =>
                      setLoginForm({
                        ...loginForm,
                        password: e,
                      })
                    }
                  />
                </div>
                <div data-test="boton" className="text-center">
                  <Button primary submit={true} size="slim">
                    ACCEDER
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div data-test="toast">
          <AlertToast />
        </div>
      </Frame>
    </>
  );
};

export default Login;
